export var LinkStyles = function LinkStyles(props) {
  var isDisabled = props.isDisabled;
  return {
    root: [!isDisabled && {
      selectors: {
        '&:active, &:hover, &:active:hover': {
          textDecoration: 'underline'
        }
      }
    }]
  };
};